import { UserNameItem } from 'modules/user';
import { useSettings } from 'context/SettingsContext';
import type { UserIncomeReportRowType } from '@econtractor/types';
import { formatIncomeLocal, formatIncomePrimary } from '../model';
import UserIncomeRowsTable from './UserIncomeRowsTable';

interface UserIncomeBlockProps {
    user: UserIncomeReportRowType;
}

const UserIncomeBlock = ({ user }: UserIncomeBlockProps) => {
    const { localSettings } = useSettings();
    const rate = Number(localSettings?.RATE?.current ?? 1) || 1;
    const isUahMode = rate === 1;
    const amount = Number(user.amount) || 0;
    const amountRate = Number(user.amountRate) || 0;

    return (
        <div className="user-income-block mb-4">
            <div className="d-flex justify-content-between align-items-center gap-3 mb-2">
                <div className="min-w-0 flex-grow-1">
                    <UserNameItem
                        user={{
                            userName: user.userName,
                            userEmail: user.userEmail,
                            userPicture: user.userPicture || undefined,
                        }}
                    />
                </div>
                <div className="text-end flex-shrink-0">
                    <h6 className="mb-0">{formatIncomePrimary(amount, rate)}</h6>
                    {!isUahMode && (
                        <p className="text-muted f-12 mb-0">{formatIncomeLocal(amountRate)}</p>
                    )}
                </div>
            </div>
            <UserIncomeRowsTable rows={user.rows || []} />
        </div>
    );
};

export default UserIncomeBlock;
